import React from "react";
import ProductAddEditManage from "Components/GMS/Products/ManageProducts/ProductAddEditManage";

function ProductAddEdit(props) {
  const { params } = props.match;

  return (
    <React.Fragment>
      <ProductAddEditManage productid={params.id} />
    </React.Fragment>
  );
}

export default ProductAddEdit;
